module.exports = __webpack_public_path__ + "img/miniPic.bc17a4c3.png";